import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "bg-color2"
}
const _hoisted_3 = {
  class: "font-bold",
  style: {"font-family":"'Courier New', Courier, monospace"}
}

import { useStore } from '@/store';

export default /*@__PURE__*/_defineComponent({
  __name: 'DebugComp',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_va_list_item = _resolveComponent("va-list-item")!
  const _component_va_list = _resolveComponent("va-list")!

  return ((_unref(store).state.debug.isDevEnv || _ctx.$router.currentRoute.value.query?.debug == 'true') && _ctx.$router.currentRoute.value.query?.debug != 'false')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(store).state.debug.content.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_va_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.debug.content, (line, index) => {
                    return (_openBlock(), _createBlock(_component_va_list_item, { key: index }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(line), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})